import { axiosLocal5000Local } from "../axios";

export async function getAllDetails(selectedSymbol:any, startPortfolioDate: any, endPortfolioDate: any,type:any ){
    let symbolList :string[] = [];
    selectedSymbol?.map((item:any) => {
        symbolList.push(String(item['s_symbol']))
    })
    return await axiosLocal5000Local.post(`equity-spot-multiday/getAllDetails`,{
        symbol: symbolList,
        startDate: startPortfolioDate,
        endDate: endPortfolioDate,
        type: type
    }).then((res:any)=>{
        return res?.data
    }).catch((error:any)=>{
        console.log("Exception occured while fetching the symbol details for historical performance : ", error)
        return {"error": true}
       
    })
}
export async function getAllSymbols(type:any){
    return await axiosLocal5000Local.post(`equity-spot-multiday/get-all-symbols`,{type:type}).then((res:any)=>{
        return res?.data
    }).catch((error:any)=>{
        console.log("Exception occured while fetching the symbol details for historical performance : ", error)
        return {"error": true}
       
    })
}

export async function getChartValues(selectedSymbol:any, startPortfolioDate: any, endPortfolioDate: any,type:any ){
    return await axiosLocal5000Local.post(`equity-spot-multiday/get-chart-details`,{
        symbol: selectedSymbol.s_symbol,
        startDate: startPortfolioDate,
        endDate: endPortfolioDate,
        type:type
    }).then((res:any)=>{
        return res?.data
    }).catch((error:any)=>{
        console.log("Exception occured while fetching the chart details for historical performance : ", error)
        return {"error": true}
    })
}